import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { HqUserState } from './type';

const initialState: HqUserState = {
  summary: {
    totalActive: 0,
    totalDisable: 0,
    total: 0,
    init: false,
  },
};

export const { actions: hqUserActions, reducer: hqUserReducer } = createSlice({
  name: 'company',
  initialState,
  reducers: {
    updateSummary(state, action: PayloadAction<Omit<HqUserState['summary'], 'total' | 'init'>>) {
      const { payload } = action;
      state.summary = {
        ...payload,
        total: payload.totalActive + payload.totalDisable,
        init: false,
      };
    },
  },
});

export * from './type';
export * from './selector';
